import React, { useEffect, useState } from "react";
// all pages
import { HomePage } from "./pages";
// Is Mobile View
import { isMobile } from "react-device-detect";

// constants
import { toAbsoluteUrl } from "../services";
import { useNavigate } from "react-router-dom";

import { connect, useSelector } from "react-redux";
import { logout } from "../redux/actions/login";

import { loadCampaigns } from "../redux/actions/premium/dashboardActions";

// import default style
import "rsuite/styles/index.less";

// get step data from redux main state
const data = (state) => state.dashboard;

let NRPRouting = (props) => {
  let navigate = useNavigate();

  const [message, setMessage] = useState(false);

  let { campaigns } = useSelector(data);

  console.log(
    "%c REPORT MODE ON!",
    "width: 100% ; border: 3px solid yellow ; border-radius: 7px ; font-weight:bold; " +
      "padding: 10px ; margin: 20px ;"
  );
  useEffect(() => {
    props.loadCampaigns();
  }, []);

  useEffect(() => {
    let total = campaigns && campaigns.length;
    if (total === 0 || total == "0") {
      setMessage(true);
      setTimeout(() => {
        navigate("/home");
      }, 2000);
    }
  }, [campaigns]);

  return isMobile === true ? (
    <div className="flex flex-col items-center justify-center mt-[30%]">
      <img src={toAbsoluteUrl("/media/login/desktop.png")} />
      <h4 className="text-center">
        This Product is available only on Desktop!
      </h4>
    </div>
  ) : (
    <div>
      {campaigns && campaigns.length > 0 ? (
        <HomePage />
      ) : campaigns && campaigns.length < 1 && message ? (
        <div className="flex my-52 justify-center items-center">
          <h1 className="text-center">No Campaign Found!</h1>
        </div>
      ) : <div className="flex my-52 justify-center items-center">
      <h1 className="text-center">Please Wait!</h1>
    </div>}
    </div>
  );
};
const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, { logout, loadCampaigns })(NRPRouting);
